import { render, staticRenderFns } from "./RoadFeatureEdit.vue?vue&type=template&id=70a622b8"
import script from "./RoadFeatureEdit.vue?vue&type=script&lang=js"
export * from "./RoadFeatureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports